import { useState } from "react";
import {
  Create,
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  Toolbar,
  EditButton,
  DateField,
  BooleanField,
  NullableBooleanInput,
  AutocompleteInput,
  ReferenceInput,
  ImageField,
  FunctionField,
  TextInput,
  useNotify,
  useRefresh,
  DateInput,
  SelectInput,
} from "react-admin";
import Slider from "./components/carousel";
import Carousel from "./components/carousel";
import UploadImage from "../shared/uploadImage";
import { AiOutlineDelete } from "react-icons/ai";
import UploadVideo from "./components/upload-video";

export const AuctionList = (props) => {
  const [showMedia, setShowMedia] = useState(false);
  const [media, setMedia] = useState();
  const [videos, setVideos] = useState();

  return (
    <>
      <List {...props}>
        <Datagrid bulkActionButtons={false}>
          <TextField source="id" />
          <TextField label="name" source="_sub_category.name" />
          <TextField source="user.phonenumber" />
          <TextField label="supervisor" source="_supervisor.name" />
          <TextField source="quantity" />
          <TextField label="unit" source="_unit.name" />
          <DateField source="startsOn" />
          <DateField source="endsOn" />
          <TextField label="state" source="_state.name" />
          <TextField label="opening price (SDG)" source="opening_price" />
          <DateField source="created_at" label="Date" />
          <TextField source="status" />
          <BooleanField source="verified" />
          <FunctionField
            label="media"
            render={(record) => (
              <div
                className="flex gap-1"
                onClick={(e) => {
                  setMedia(
                    record.images?.length > 1
                      ? record.images.map((e) => e)
                      : record.images
                  );
                  setShowMedia(true);
                  setVideos(record.video);
                }}
              >
                {record.images.slice(0, 3).map((e) => (
                  <img src={e} className="w-10 " />
                ))}
                {record.video.slice(0, 1).map((e) => (
                  <video src={e} className="w-12 " />
                ))}
              </div>
            )}
          />
          <EditButton></EditButton>
        </Datagrid>
      </List>
      {showMedia && (
        <Carousel slides={media} setShowMedia={setShowMedia} videos={videos} />
      )}
    </>
  );
};

// export const AuctionCreate = (props) => {
//   return (
//     <Create title="Create a Sub-Category " {...props} dir="rtl" redirect="list">
//       <SimpleForm>
//         <TextInput source="name" />
//         <UploadImage name="image" />
//       </SimpleForm>
//     </Create>
//   );
// };

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const AuctionEdit = (props) => {
  const notify = useNotify();
    const refresh = useRefresh();

  async function deleteImg(record, url) {
    const images = [...record.images];
    const body = JSON.stringify({ images: images.filter((e) => e !== url) });
    const response = await fetch(
      // `http://localhost:3060` + "/admin/auctions/" + record.id,
      `https://api.mahsool.sd` + "/admin/auctions/" + record.id,
      {
        method: "PATCH",
        body: body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
        },
      }
    ).then((res) => res.json());
    if (response.message === "images should not be empty") {
      notify(`Upload the new one and save then try to delete`, {
        type: "error",
      });
    } else {
      // window.location.reload();
      refresh()
    }
  }
  async function deleteVid(record, url) {
    const videos = [...record.video];
    const body = JSON.stringify({ video: videos.filter((e) => e !== url) });
    const response = await fetch(
      // `https://api.mahsool.sd`
      `http://localhost:3060` + "/admin/auctions/" + record.id,
      {
        method: "PATCH",
        body: body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
        },
      }
    ).then((res) => res.json());
    if (response) {
      // window.location.reload();
      refresh()
    }
  }

  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <NullableBooleanInput label="verified" source="verified" />
        <DateInput source="startsOn" />
        <SelectInput
          source="status"
          choices={[
            { id: "Open", name: "Open" },
            { id: "Pending", name: "Pending" },
            { id: "Closed", name: "Closed" },
          ]}
        />
        <TextInput multiline fullWidth source="description" />
        <ReferenceInput source="supervisor" reference="admins/supervisors">
          <AutocompleteInput fullWidth optionText="username" value="id" />
        </ReferenceInput>
        <FunctionField
          key="1"
          label="media"
          render={(record) => (
            <div className="flex  w-full gap-3 ">
              {record.images.map((e, index) => (
                <div className="w-[15rem] relative h-full ">
                  <img
                    key={index}
                    src={e}
                    className={`w-[full] h-full `}
                    // onClick={() => setImageUrl(e)}
                  />
                  <div
                    onClick={() => deleteImg(record, e)}
                    className="absolute top-1 right-1 hover:cursor-pointer p-1 bg-black/30  border border-red-500 rounded-full"
                  >
                    {" "}
                    <AiOutlineDelete className="text-red-500 text-xl" />{" "}
                  </div>
                </div>
              ))}
              {record.video.map((e, index) => (
                <div className="w-[15rem] relative h-full">
                  <video
                    key={index}
                    src={e}
                    controls
                    className="w-full object-cover h-full "
                    // onClick={() => setVideoUrl(e)}
                  />
                  <div
                    onClick={() => deleteVid(record, e)}
                    className="absolute top-1 right-1 hover:cursor-pointer p-1 bg-white/30  border border-red-500 rounded-full"
                  >
                    {" "}
                    <AiOutlineDelete className="text-red-500 text-xl" />{" "}
                  </div>
                </div>
              ))}
            </div>
          )}
        />
        <h1 className="my-6">Upload an Image</h1>

        <div className="mb-6 w-full rounded-lg p-2 border border-green-600 text-center ">
          <FunctionField
            key="2"
            render={(record) => <UploadImage name="images" record={record} />}
          />
        </div>
        <h1 className="my-6">Upload a Video</h1>
        <div className="mb-6 w-full rounded-lg p-2 border border-green-600 text-center">
          <FunctionField
            key="3"
            render={(record) => <UploadVideo name="video" record={record} />}
          />
        </div>
      </SimpleForm>
    </Edit>
  );
};
